import gql from "graphql-tag";

export const IS_EVENT_NAME_EXIST = gql`
  query events_aggregate($name: String) {
    is_name_exist: events_aggregate(where: { name: { _eq: $name } }) {
      aggregate {
        count
      }
    }
  }
`;
